export const GENELINK_BANNERS = [
  {
    id: 'genelife-fitness',
    creative_id: process.env.REACT_APP_GENELINK_CREATIVE_ID_1,
    image: '/image/genelink/genelife_banner_450-120.png',
  },
  {
    id: 'glutamine',
    creative_id: process.env.REACT_APP_GENELINK_CREATIVE_ID_2,
    image: '/image/genelink/GLUT2.png',
  },
];



// WEBPACK FOOTER //
// ./src/constants/GeneLinkBanners.js